<template>
  <div class="fifth">
    <div class="fifth_bg"></div>
    <div class="shoppingcart"></div>
    <div class="title"></div>
    <div class="title2"></div>

    <div class="hitcall"></div>
    <div class="pCall"></div>

    <div class="wtjz"></div>
    <div class="htjz"></div>
    <div class="h1"></div>
    <div class="h2"></div>
    <div class="h3"></div>
    <div class="h4"></div>
    <div class="h5"></div>



    <div class="noice"></div>
    <div class="noice2"></div>
    <div class="noice3"></div>
    <div class="noice4"></div>
    <div class="setUp" @click="poster"></div>

    <div class="f1 fdown1"></div>
    <div class="f2 fdown2"></div>
    <div class="f3 fdown3"></div>
    <div class="f4 fdown4"></div>
    <div class="f5 fdown5"></div>
    <div class="f1 fdown6"></div>
    <div class="f3 fdown7"></div>

<!--    <div class="gongzhonghao"></div>-->
    <img src="../../public/guangming_milk/gongzhonghao2.jpg" class="gongzhonghao" alt="">
  </div>
</template>

<script>

export default {
  name: "fifth.vue",
  data() {
    return{
    }
  },
  mounted() {
  },
  methods:{
    poster(){
      this.$router.push('/setPoster')
    },
  }
}
</script>

<style scoped>
@import "../animationcss/animatie.css";

.fifth{
  width: 750px;
  height: calc(3628px - 50px);
  position: relative;
}
.fifth_bg{
  width: 750px;
  height: 3628px;
  background: url("../../public/guangming_milk/5/5_bg3.jpg") no-repeat;
  background-size: 100% 100%;
  /*background-position: 0 -58px;*/
  position: absolute;
  left: 0;
  top: -59px;
  z-index: 8;
}
.title{
  width: 505px;
  height: 173px;
  background: url("../../public/guangming_milk/title/5-title.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 10px;
  top: 5px;
  z-index: 10;
}
.title2{
  width: 516px;
  height: 130px;
  background: url("../../public/guangming_milk/title/5-title2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 80px;
  bottom: 1380px;
  z-index: 10;
}
.shoppingcart{
  width: 209px;
  height: 170px;
  background: url("../../public/guangming_milk/png/shoppingcart2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 9;
  right: 10px;
  top: -40px;
}


.hitcall{
  width: 750px;
  height: 647px;
  background: url("../../public/guangming_milk/5/call3.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 9;
  bottom: 700px;
  left: calc(50% - 375px);
}
.pCall{
  /*width: 741px;*/
  /*height: 377px;*/
  /*background: url("../../public/guangming_milk/5/callren.png") no-repeat;*/
  /*background-size: 100%;*/
  /*position: absolute;*/
  /*z-index: 10;*/
  /*bottom: 720px;*/
  /*left: 6px;*/
}




/*生成海报样式*/
.setUp{
  width: 350px;
  height: 550px;
  /*background: #3F8853;*/
  position: absolute;
  z-index: 50;
  left: calc(50% - 175px);
  bottom: 760px;
}

.noice{
  width: 107px;
  height: 74px;
  background: url("../../public/guangming_milk/png/noicex.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1057px;
  left: 20px;
  z-index: 10;
  animation: showNoice 1s linear infinite;
}
.noice3{
  width: 107px;
  height: 74px;
  background: url("../../public/guangming_milk/png/noicex.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1477px;
  right: 27px;
  z-index: 10;
  transform: rotate(-60deg);
  animation: showNoice 0.7s linear infinite;
}

.noice2{
  width: 169px;
  height: 52px;
  background: url("../../public/guangming_milk/png/noicex2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1057px;
  left: 532px;
  z-index: 10;
  animation: showNoice 1s linear infinite;
}.noice4{
  width: 169px;
  height: 52px;
  background: url("../../public/guangming_milk/png/noicex2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1357.5px;
  left: 59.5px;
  z-index: 10;
  animation: showNoice 0.8s linear infinite;
}
@keyframes  showNoice{
  from{opacity: 0}
  to{opacity: 1}
}

.wtjz{
  width: 750px;
  height: 962px;
  background: url("../../public/guangming_milk/5/wutaijaizu2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 132.4px;
  z-index: 9;
}
.htjz{
  width: 500px;
  height: 913px;
  background: url("../../public/guangming_milk/5/htjz.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1068.75px;
  left: 148px;
  z-index: 9;
}
.h1{
  /*小樽人物1*/
  width: 30px;
  height: 30px;
  background: url("../../public/guangming_milk/5/h1.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1145px;
  left: 198px;
  z-index: 10;
}.h2{
  /*小樽人物1*/
  width: 50px;
  height: 30px;
  background: url("../../public/guangming_milk/5/h2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1207.5px;
  left: 287px;
  z-index: 10;
}.h3{
  /*小樽人物1*/
  width: 50px;
  height: 20px;
  background: url("../../public/guangming_milk/5/h3.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1501px;
  left: 562px;
  z-index: 10;
}
.h4{
  width: 48px;
  height: 40px;
  background: url("../../public/guangming_milk/5/h4.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1545px;
  left: 412px;
  z-index: 10;
}.h5{
  width: 72px;
  height: 72px;
  background: url("../../public/guangming_milk/5/h5.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1753px;
  left: 399px;
  z-index: 10;
}

.f1{
  width: 35px;
  height: 53px;
  background: url("../../public/guangming_milk/png/hua1.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}.f2{
  width: 47px;
  height: 40px;
  background: url("../../public/guangming_milk/png/hua2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}.f3{
  width: 21px;
  height: 40px;
  background: url("../../public/guangming_milk/png/hua3.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}.f4{
  width: 21px;
  height: 47px;
  background: url("../../public/guangming_milk/png/hua4.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}.f5{
  width: 19px;
  height: 41px;
  background: url("../../public/guangming_milk/png/hua5.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}
.fdown1{
  top: 290px;
  left: 25px;
  animation: snowDown 18s linear infinite normal;
  -webkit-animation: snowDown 18s linear infinite normal;
}.fdown2{
  top: 250px;
  left: 75px;
  animation: snowDown 15s linear infinite normal;
  -webkit-animation: snowDown 15s linear infinite normal;
}.fdown3{
  top: 350px;
  left: 225px;
  animation: snowDown 16.5s linear infinite normal;
  -webkit-animation: snowDown 16.5s linear infinite normal;
}.fdown4{
  top: 225px;
  left: 298px;
  animation: snowDown 19s linear infinite normal;
  -webkit-animation: snowDown 19s linear infinite normal;
}.fdown5{
  top: 205px;
  left: 482px;
  animation: snowDown 18.6s linear infinite normal;
  -webkit-animation: snowDown 18.6s linear infinite normal;
}.fdown6{
  top: 322px;
  left: 690px;
  animation: snowDown 16.6s linear infinite normal;
  -webkit-animation: snowDown 16.6s linear infinite normal;
}.fdown7{
  top: 300px;
  left: 580px;
  animation: snowDown 15.6s linear infinite normal;
  -webkit-animation: snowDown 15.6s linear infinite normal;
}
@keyframes snowDown {
  0% {
    opacity: 1;
  }
  70%{
    opacity: 1;
  }
  100% {
    opacity: 0;
    top: 2000px;
    transform: rotate(360deg);
  }
}

.gongzhonghao{
  /*width: 400px;*/
  /*height: 400px;  */
  width: 108px;
  height: 108px;
  /*background: url("../../public/guangming_milk/gongzhonghao.jpg") no-repeat;*/
  /*background-size: 108px 108px;*/
  /*background-position: center center;*/
  position: absolute;
  z-index: 50;
  /*bottom: 142px;*/
  /*left: 240px;  */
  bottom: 290px;
  left: 390px;
}
</style>
